import { DEFAULT_AUDIENCE_COUNT_NAME } from '../../domain';
import { useTranslation } from '../../hooks/useTranslation';

export const useFormatAudienceName = () => {
  const { t } = useTranslation();
  return (name: string) =>
    !name.length || name === DEFAULT_AUDIENCE_COUNT_NAME ? t('insights.unknown') : name;
};
